// extracted by mini-css-extract-plugin
export default {"row":"hero_row__K1BPr","col":"hero_col__qDFvh","arrow":"hero_arrow__9JW9J","icon":"hero_icon__NEJCt"};